import * as SwitchButton from '@radix-ui/react-switch'
import { root, thumb } from './styles.css'

interface ISwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

const Switch = ({ checked, onChange, disabled }: ISwitchProps) => {
  return (
    <SwitchButton.Root
      checked={checked}
      onCheckedChange={onChange}
      className={root}
      disabled={disabled}
    >
      <SwitchButton.Thumb className={thumb} />
    </SwitchButton.Root>
  )
}

export default Switch
